(function($) {
	if ($('.historyPage').length) {

		var event1 = $('.event').eq(0);
		var event_last = $('.event').eq($('.event').length-1);
		event_last.addClass('last-event');
		event1.addClass('first-event');

		var event_last_parent = event_last.closest('.events');
		if(event_last_parent.children().length>1) event_last_parent.addClass('more2children');

		var active_position = event1.offset().top + 50;
		if($(document).width() < 768) active_position = event1.offset().top;
		
		var scrollPos = 0;

		$(window).on('scroll', function(event) {
			if($(document).width() > 2100) {
				var st = $(this).scrollTop();
				if (st > scrollPos ){// down
					active_position = event1.offset().top + 200;
				} else {// up
					active_position = event1.offset().top + 50;
				}
				scrollPos = st;
			}
			//$('#acp').css('top',active_position+'px');

			

			$('.event').each(function(){
				var top = 0;

					if( $(this).offset().top - $(window).scrollTop() <= active_position && $(this).offset().top + parseFloat($(this).outerHeight()) - $(window).scrollTop() > active_position ) {
						$(this).addClass('active');
						$(this).closest('.item').addClass('active');
						top = $(this).position().top + $(this).outerHeight()/2 - $(this).closest('.year-item').find('.year').outerHeight()/2; 
						if(!$(this).hasClass('first-event')) $(this).closest('.year-item').find('.year').css('top', top+'px');
						else $(this).closest('.year-item').find('.year').css('top', '0px');
					} else {
						$(this).removeClass('active');
						if(!$(this).closest('.item').find('.event.active').length ) $(this).closest('.item').removeClass('active');
						//$(this).closest('.year-item').find('.year').css('top', 0);
					}
			});

		});
	}
})(jQuery);